import {
  Centred,
  Contents,
  LinkText,
  MainFloat,
  Margins,
  RichText,
  Btn,
  Page,
} from '../../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  contents: {
    ...Contents(theme),
    maxWidth: 1200,
    padding: '0 1.5rem 0 1.5rem'
  },
  mainFloat: {
    ...MainFloat(theme),
    marginTop: '-30%',
    position: 'relative',
  },
  margins: {
    ...Margins(theme),
  },
  btn: {
    ...Btn(theme),
  },
  linkText: {
    ...LinkText(theme),
  },
  richText: {
    ...RichText(theme),
  },
  page: {
    ...Page(theme),
  },
  topper: {
    background: '#fff',
    padding: '7rem 7rem 0 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },

    '& h1': {
      textTransform: 'uppercase',
      fontWeight: 800,
      lineHeight: 1,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.headline.fontSize,
        wordBreak: 'break-word',
      },
    },
    '& h3': {
      textTransform: 'uppercase',
    },
  },
  topper_teams_as_a_service: { color: theme.brand && theme.brand.taas.navText },
  topper_fixed_cost_project: { color: theme.brand && theme.brand.fixed.navText },
  lead: {
    background: '#fff',
    padding: '3rem 7rem 3rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  leadText: {
    fontSize: theme.typography.subheading.fontSize,
    fontWeight: 400
  },
  lister: {
    background: '#fff',
    padding: '3rem 7rem 3rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  listerItems: {
    marginTop: theme.spacing.unit * 5,
  },
  listerItem: {
    padding: 20,
    background: '#efefef',
    marginBottom: 20,
  },
  listerLink: {
    marginTop: theme.spacing.unit * 2,
  },
  listerImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  listerImage: {
    height: 120,
    width: 120,
    borderRadius: 4
  },
  boxer: {
    background: '#fff',
    padding: '3rem 7rem 3rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  boxerContents: {
    marginBottom: theme.spacing.unit * 10
  },
    selectedResource: {
    background: '#7ED321',
    margin: 20,
    fontSize:18,
    color: "#fff"
  },
  contenter: {
    background: '#fff',
    padding: '3rem 7rem 3rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  contenterImage: {
    height: 500,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit * 10,
    [theme.breakpoints.down('sm')]: {
      height: 200,
    },
  },
  linker: {
    background: '#fff',
    padding: '3rem 7rem 7rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  focuser: {
    background: '#fff',
    padding: '1rem 7rem 3rem 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
    '& h1': {
      marginBottom: theme.spacing.unit
    }
  },
  focusSectionImage: {
    width: '100%',
    height: 500,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit * 5,
    [theme.breakpoints.down('sm')]: {
      height: 200,
    },
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/styles.js